<ng-container>
  <form #multiForm id="multiForm">
    <div [innerHTML]="formString | safeHtml"></div>
  </form>
</ng-container>
